import {
  legacy_createStore as createStore,
  applyMiddleware,
  compose,
} from "redux";
import thunk from "redux-thunk";
import rootReducer from "./reducers";
import { initialState as generalSettingsInitialState } from "./reducers/generalSettings";

// Reads a boolean setting from localStorage, falling back when missing or unreadable.
const readStoredBoolean = (key, fallback) => {
  try {
    const value = JSON.parse(localStorage.getItem(key));
    return typeof value === "boolean" ? value : fallback;
  } catch {
    return fallback;
  }
};

const preloadedState = {
  generalSettings: {
    ...generalSettingsInitialState,
    includeHiddenSites: readStoredBoolean("includeHiddenSites", false),
    includeEmptySites: readStoredBoolean("includeEmptySites", true),
  },
};

const middlewareEnhancer = applyMiddleware(thunk);
const composeEnhancers =
  window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const enhancers = composeEnhancers(middlewareEnhancer);

const store = createStore(rootReducer, preloadedState, enhancers);

let lastPersisted = null;
store.subscribe(() => {
  const { generalSettings } = store.getState();
  if (generalSettings === lastPersisted) return;
  lastPersisted = generalSettings;
  localStorage.setItem(
    "includeHiddenSites",
    JSON.stringify(generalSettings.includeHiddenSites)
  );
  localStorage.setItem(
    "includeEmptySites",
    JSON.stringify(generalSettings.includeEmptySites)
  );
});

export default store;
